import _ from 'lodash';
import { getShopId } from '../../apis/shop.service';
import {
  DELIVERY_HOUR_ROUTE,
  ERROR_UPDATE_CONFIG,
  INITIAL_HOUR_VALUE,
  SUCCESS_UPDATE_TEXT
} from '../../constants';
import { sendCloudWatchAlert } from '../../utils/applicationError';
import { showNotification } from '../Notification/Notification.view';
import apiService from '@dishopsaas/dishop-backend-api-service'

export const initDataConfig = async (newProps, component) => {
  const { checkBox } = component.state;
  const { configurations, location } = newProps;
  const { pathname } = location;
  let matched = true;
  const { hours: configHours = {} } = configurations;
  if (pathname === DELIVERY_HOUR_ROUTE) {
    matched = false;
  }
  const hours = _.cloneDeep(configHours);

  _.map(hours, (day, dayKey) => {
    const { slots, slotsDelivery } = day;
    if (matched) {
      if (!slots || slots.every(slot => slot === INITIAL_HOUR_VALUE)) {
        checkBox[dayKey] = false;
        day.slots = [];
        day.slots.push(INITIAL_HOUR_VALUE);
      } else {
        checkBox[dayKey] = true;
      }
    } else if (!slotsDelivery || slotsDelivery.every(slot => slot === INITIAL_HOUR_VALUE)) {
      checkBox[dayKey] = false;
      day.slotsDelivery = [];
      day.slotsDelivery.push(INITIAL_HOUR_VALUE);
    } else {
      checkBox[dayKey] = true;
    }
  });
  const data = handleConfig(hours);
  await component.setState(prevStates => ({
    checkBox: checkBox || prevStates.checkBox,
    slotType: matched ? 'slots' : 'slotsDelivery',
    data  
  }));
};

export const handleConfig = hours => {
  const data = {
    openHours: {}
  };
  _.map(hours, (day, dayKey) => {
    data.openHours[dayKey] = {
      name: day.name,
      slots: [],
      slotsDelivery: []
    };
    const { slots = [], slotsDelivery = [], limits = [], limitsDelivery = [] } = day;
    slots.forEach((hour, key) => {
      const newSlot = { start: hour.split('-')[0], end: hour.split('-')[1] };
      if (limits[key] >= 0) newSlot.limit = limits[key];
      data.openHours[dayKey].slots.push(newSlot);
    });
    slotsDelivery.forEach((hour, key) => {
      const newSlot = { start: hour.split('-')[0], end: hour.split('-')[1] };
      if (limitsDelivery[key] >= 0) newSlot.limitDelivery = limitsDelivery[key];
      data.openHours[dayKey].slotsDelivery.push(newSlot);
    });
  });
  return data;
}

export const handleChangeOpenHours = (day, serviceNumber, time, type, key, component) => {
  const { data = {} } = component.state;
  const { openHours = {} } = data;
  const hour = `${time === '' ? '00:00' : time}`;
  const newSlots = [...openHours[day][type]];
  const slotId = getUniqueSlotId(day, serviceNumber, type);
  component.setState((prevState) => ({
    slotErrorMessages: {
      ...prevState.slotErrorMessages,
      [slotId]: (key === 'start' && hour >= newSlots[serviceNumber].end) || (key === 'end' && hour <= newSlots[serviceNumber].start)
        ? 'Les heures ne sont pas cohérentes':'' }
  }));
  newSlots[serviceNumber] = {
    ...newSlots[serviceNumber],
    [key]: hour
  };

  component.setState({
    data: {
      ...data,
      openHours: {
        ...openHours,
        [day]: {
          ...openHours[day],
          [type]: newSlots
        }
      }
    }
  });
};

export const getUniqueSlotId = (day, serviceNumber, type) => `${day}-${serviceNumber}-${type}`;
export const handleChangeSwitch = (day, type, component) => {
  component.setState(prevState => {
    const { checkBox } = prevState;
    return {
      checkBox: {
        ...checkBox,
        [day]: !checkBox[day]
      }
    };
  });
}
export const sortedSlots = (slots) => {
  const sortedSlots= slots.sort((a, b) => {
    const dateA = new Date(`2000-01-01T${a.start}`);
    const dateB = new Date(`2000-01-01T${b.start}`);
    return dateA - dateB;
  });
  return sortedSlots
}
export const handleAddHours = (day, type, component) => {
  const { data } = component.state;
  const { openHours } = data;
  openHours[day][type].push({
    start: '00:00',
    end: '23:59'
  });
  component.setState({ data: { ...data, openHours } });
}

export const handleRemoveHours = (day, hour, type, component) => {
  const { data = {} } = component.state;
  const { openHours = {} } = data;
  if (openHours[day] && openHours[day][type].length > 1) {
    openHours[day][type].splice(hour, 1);
  }
  component.setState({ data: { ...data, openHours } });
}

export const handleSubmitData = async (e, component) => {
  const { openErrorModal } = component.props;
  const { data, checkBox, slotType, slotErrorMessages } = component.state;
  const hasErrors = Object.values(slotErrorMessages).some((errorMessage) => errorMessage !== '');
  if (hasErrors) {
    return;
  }

  const { configurations: shop } = component.props;
  const { hours: oldOpenHours = {} } = shop;
  const { openHours } = data;
  const hours = { ...openHours };
  try {
    component.setState({ isLoading: true });
    e.preventDefault();
    e.stopPropagation();
    if (openHours) _.map(openHours, (day, key) => {
      let { slots = [], slotsDelivery = [] } = day;
      slots = sortedSlots(slots)
      slotsDelivery = sortedSlots(slotsDelivery)
      hours[key] = {
        ...oldOpenHours[key],
        slots: [],
        limits: [],
        limitsDelivery: [],
        slotsDelivery: []
      };

      slots.forEach((service, index) => {
        hours[key].slots = addHours(hours[key].slots, service);
        if (service.limit && service.limit !== '00:00') {
          hours[key].limits = addLimits(hours[key].limits, service.limit, index);
        }
      });
      slotsDelivery.forEach((service, index) => {
        hours[key].slotsDelivery = addHours(hours[key].slotsDelivery, service);
        if (service.limitDelivery && service.limit !== '00:00')
          hours[key].limitsDelivery = addLimits(
            hours[key].limitsDelivery,
            service.limitDelivery,
            index
          );
      });
    });
    let dataToFirebase = { hours };
    dataToFirebase = handleCheckBoxConfig(dataToFirebase, checkBox, slotType)

    await apiService.shopsUpsert([getShopId(), 'hours'], dataToFirebase.hours, { updateMode: 'merge' })

    showNotification(
      'light',
      'ltr',
      'primary',
      SUCCESS_UPDATE_TEXT,
      `Les horaires ${slotType === 'slots' ? "d'ouverture" : 'de livraison'} ont bien été modifiés.`
    );
  } catch (error) {
    sendCloudWatchAlert(`Error update hours configuration ${error}`);
    openErrorModal(ERROR_UPDATE_CONFIG);
  }
  component.setState({ isLoading: false });
}

const handleCheckBoxConfig = (data, checkbox, type) => {
  const { hours = {} } = data;
  _.map(checkbox, (day, key) => {
    if (!day) {
      delete hours[key][type];
    } else {
      _.filter(hours[key][type], hour => hour === INITIAL_HOUR_VALUE);
    }
  });
  return data;
}

const addHours = (slots, service) => {
  const { start = '00:00', end = '00:00' } = service;
  const entireSlot = `${start}-${end}`;
  if (start < end || start !== end) {
    slots.push(entireSlot);
  }
  return slots;
}

const addLimits = (limits, limit = 0, index) => {
  limits[index] = parseInt(limit, 10);
  return limits;
}
